import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useCreateTag, useSpaceTags } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { MultiselectCreatable } from '@tribeplatform/react-ui-kit/Multiselect';
import { useDebounce } from '../common/hooks/useDebounce';
import { T } from '../i18n';
const tagTitleMap = {};
export const TagPickerCreatable = (props) => {
    const { value: valueOriginal, onChange: onChangeOriginal, placeholder, } = props;
    const [search, setSearch] = useState('');
    const debouncedQuery = useDebounce(search, 300);
    const { data, isFetching, refetch } = useSpaceTags({
        variables: {
            query: debouncedQuery,
            limit: 20,
        },
    });
    const tags = useMemo(() => { var _a; return ((_a = simplifyPaginatedResult(data)) === null || _a === void 0 ? void 0 : _a.nodes) || []; }, [data]);
    const { mutateAsync: createTag, isLoading: isCreating } = useCreateTag({
        fields: 'basic',
    });
    const options = useMemo(() => (tags === null || tags === void 0 ? void 0 : tags.map(t => t.title)) || [], [tags]);
    const value = useMemo(() => valueOriginal.map(tag => tag === null || tag === void 0 ? void 0 : tag.title), [valueOriginal]);
    useMemo(() => {
        tags.forEach(t => {
            tagTitleMap[t.title] = t;
        });
        valueOriginal === null || valueOriginal === void 0 ? void 0 : valueOriginal.forEach(t => {
            tagTitleMap[t.title] = t;
        });
    }, [tags, valueOriginal]);
    const onChange = newTags => {
        onChangeOriginal(newTags.map(title => tagTitleMap[title]).filter(it => !!it));
    };
    const onCreateItem = async (inputValue) => {
        createTag({
            input: {
                title: inputValue,
            },
        }).then(result => {
            onChangeOriginal([...valueOriginal, result]);
            refetch();
        });
    };
    return (_jsxs(MultiselectCreatable, { options: options, value: value, onChange: onChange, searchable: true, onInputChange: setSearch, onCreateItem: onCreateItem, createItemPosition: "first", children: [_jsx(MultiselectCreatable.Button, { placeholder: placeholder, leadingIcon: isFetching ||
                    (isCreating && (_jsx(SpinnerIcon, { className: "self-center h-5 w-5 animate-spin" }, void 0))) }, void 0), _jsx(MultiselectCreatable.Items, { children: ({ creating, inputValue }) => {
                    return (_jsxs(_Fragment, { children: [creating && (search === null || search === void 0 ? void 0 : search.length) > 0 && !isFetching && (_jsxs(MultiselectCreatable.Item, { value: search, index: 0, children: [_jsx("span", { children: _jsx(T, { id: "Generics.Create", defaultMessage: "Create" }, void 0) }, void 0), ' ', _jsx("span", { className: "font-bold", children: search }, void 0)] }, void 0)), options.length > 0 &&
                                options.map((tag, index) => (_jsx(MultiselectCreatable.Item, { value: tag, index: index + (creating ? 1 : 0), children: _jsx("span", { children: tag }, void 0) }, tag))), isFetching ? (_jsx(MultiselectCreatable.Item, { disabled: true, value: ":_search", index: creating ? 1 : 0, children: _jsx("span", { children: _jsx(T, { id: "EntityPicker.TagPickerCreatable.SearchingForText", defaultMessage: "Searching for {search_term}...", values: { search_term: inputValue } }, void 0) }, void 0) }, ":_search")) : (options.length === 0 && (_jsx(MultiselectCreatable.Item, { disabled: true, value: ":_none", index: creating ? 1 : 0, children: _jsx("span", { children: _jsx(T, { id: "EntityPicker.TagPickerCreatable.NoResultsForTerm", defaultMessage: "No matching results for {search_term}...", values: { search_term: inputValue } }, void 0) }, void 0) }, ":_none")))] }, void 0));
                } }, void 0)] }, void 0));
};
//# sourceMappingURL=TagPickerCreatable.js.map